<!-- <ng-container>
  <div class="dialog-container">
    <ng-container *ngIf="isSupportPanelOpen && (isMobile$ | async)">
      <div
        [@slideInOutAnimation]="isSupportPanelOpen ? 'in' : 'out'"
        class="mobile-dialog-dropdown-menu"
      >
        <div class="location-main-container">
          <app-locator-main
            [flow]="flow"
            [google]="google"
            [labels]="labels"
            (upOnClose)="upOnClose()"
          ></app-locator-main>
        </div>
      </div>
    </ng-container>
  </div>
  <ng-container *ngIf="(isMobile$ | async) && isSupportPanelOpen">
    <div
      [@overlayFadeInOutAnimation]
      (click)="$event.stopPropagation()"
      class="overlay"
      [ngClass]="{ active: isSupportPanelOpen && (isMobile$ | async) }"
    ></div>
  </ng-container>
</ng-container> -->

<!-- <section class="web-main-location-map">
  <div class="contain-web-size">
    <div class="wrap-elements">
      <div class="close-button-container">
        <img
          src="assets\images\close-black-icon.svg"
          alt="close-icon"
          (click)="upOnClose()"
        />
      </div>
      <div class="modal-content">
        <app-locator-main
          [flow]="flow"
          [google]="google"
          [labels]="labels"
        ></app-locator-main>
      </div>
    </div>
  </div>
</section> -->
<div class="outer-container">
  <ng-container  *ngIf="isSupportPanelOpen && !(isMobile$ | async); else mobileLocatorView">
    <div class="web-view-locator-container">
      <div class="close-dailog-button">
        <img
          src="assets\images\close-black-icon.svg"
          alt="close-icon"
          (click)="upOnClose()"
        />
      </div>
      <div class="web-locator-dailog">
        <app-locator-main
        [flow]="flow"
        [google]="google"
        [labels]="labels"
        (upOnClose)="upOnClose()"
      ></app-locator-main>
      </div>
    </div>
  </ng-container>
  <ng-template #mobileLocatorView>
    <div class="mobile-locator-dialog"  [@slideInOutAnimation]="isSupportPanelOpen ? 'in' : 'out'">
      <app-locator-main
      [flow]="flow"
      [google]="google"
      [labels]="labels"
      (upOnClose)="upOnClose()"
    ></app-locator-main>
    </div>
  </ng-template>
</div>